<template>
  <b-dropdown :value="value" @input="onStatusSelected" aria-role="list">
    <!-- Button-->
    <button class="button" type="button" slot="trigger">
      <b-icon :icon="statusOption.icon"></b-icon>
      <span>
        <span class="has-text-grey-light">Status:</span>
        {{ statusOption.label }}
      </span>
      <b-icon icon="menu-down"></b-icon>
    </button>

    <!-- Options to choose-->
    <b-dropdown-item v-for="s in statusOptions" :key="s.value" :value="s.value" aria-role="listitem">
      {{ s.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    name: "StatusSelector",
    props: {
      value: { type: String, required: false, default: null }
    },
    data() {
      return {
        statusOptions: [
          { value: null, label: 'Any status', icon: 'flag-triangle' },
          { value: 'pending', label: 'Pending', icon: 'progress-clock' },
          { value: 'processing', label: 'Processing', icon: 'progress-download' },
          { value: 'processed', label: 'Processed', icon: 'progress-check' },
          { value: 'failed', label: 'Failed', icon: 'progress-alert' }
        ]
      }
    },
    computed: {
      statusOption () {
        return this.statusOptions.find(s => s.value === this.value)
      }
    },
    methods: {
      onStatusSelected(value) {
        this.$emit('input', value)
      }
    }
  }
</script>
